<template>
  <div>
    <router-view v-if="isPwaLayout || !isLayoutDefined" />
    <component
      v-else
      :is="layout"
    />
    <PwaInstallPrompt />
  </div>
</template>

<script>
const default_layout = "white"
const available_layouts = ["default", "unauthenticated", "white"]

import DefaultLayout from "@/components/layouts/DefaultLayout.vue"
import UnauthenticatedLayout from "@/components/layouts/UnauthenticatedLayout.vue"
import WhiteLayout from "@/components/layouts/WhiteLayout.vue"
import PwaInstallPrompt from "@/components/layouts/PwaInstallPrompt.vue"

export default {
  components: {
    DefaultLayout,
    UnauthenticatedLayout,
    WhiteLayout,
    PwaInstallPrompt
  },
  computed: {
    isPwaLayout() {
      return this.$route.meta.layout === 'pwa'
    },
    isLayoutDefined() {
      return !!this.$route.meta.layout
    },
    layout() {
      const name = available_layouts.includes(this.$route.meta.layout)
        ? this.$route.meta.layout
        : default_layout
      return `${name}-layout`
    }
  },
  methods: {},
  mounted() {
    if (this.$store.getters["app/isSignedIn"]) this.$store.dispatch("app/fetchNotifications")
  }
}
</script>
<style src="./assets/styles/mobile-styles.css"></style>